if (!customElements.get('science-slider')) {
  customElements.define('science-slider', class ScienceSlider extends HTMLElement {
    connectedCallback() {
      this._init();
    }

    disconnectedCallback() {
      this._destroy();
    }

    _init() {
      if (typeof Swiper === 'undefined') return;
      if (this._swiper) return;

      const container = this.querySelector('.swiper');
      if (!container) return;

      const prevBtn = this.querySelector('[data-slider-prev]');
      const nextBtn = this.querySelector('[data-slider-next]');

      this._swiper = new Swiper(container, {
        slidesPerView: 1.75,
        spaceBetween: 24,
        watchOverflow: true,

        navigation: prevBtn && nextBtn ? {
          prevEl: prevBtn,
          nextEl: nextBtn,
          disabledClass: 'is-disabled',
        } : false,

        breakpoints: {
          768: {
            slidesPerView: 2.75,
          },
          990: {
            slidesPerView: 3.75,
          },
          1024: {
            slidesPerView: 4.25,
          },
          1200: {
            slidesPerView: 5.25,
          },
          1920: {
            slidesPerView: 6,
            spaceBetween: 4,
            allowTouchMove: false,
          },
        },
      });
    }

    _destroy() {
      if (this._swiper) {
        this._swiper.destroy(true, true);
        this._swiper = null;
      }
    }
  });
}
